import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function NotFound(props) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/');
  }, []);

  return null;
}
